import { Post } from '../types';

export const mockPosts: Post[] = [
  {
    id: '1',
    profileName: 'Bill Car Rent a Car',
    date: '2025-11-11',
    time: '08:00',
    text: 'Aproveite nossos carros novos com preços especiais! Entre em contato e faça já sua reserva.',
    images: ['https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800'],
    status: 'scheduled',
    tone: 'automatic',
    emoticons: 'automatic',
    wordCount: 25,
    createdAt: '2025-11-10T10:00:00Z'
  },
  {
    id: '2',
    profileName: 'Bill Car Rent a Car',
    date: '2025-11-15',
    time: '10:00',
    text: 'Final de semana chegando! Que tal alugar um carro para aquela viagem dos sonhos? Temos as melhores condições do mercado.',
    images: [],
    status: 'scheduled',
    tone: 'casual',
    emoticons: 'yes',
    wordCount: 30,
    createdAt: '2025-11-10T11:00:00Z'
  },
  {
    id: '3',
    profileName: 'Bill Car Rent a Car',
    date: '2025-11-20',
    time: '14:00',
    text: 'Novidade! Agora temos carros elétricos disponíveis para locação. Sustentabilidade e economia juntas.',
    images: ['https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800'],
    status: 'draft',
    tone: 'professional',
    emoticons: 'no',
    wordCount: 20,
    createdAt: '2025-11-10T12:00:00Z'
  }
];
